export default __webpack_public_path__ + "static/media/errorIcon~HvdaekLZ.6744f109.svg";